/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    className: 'll-mpf',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      if ( $( '.ll-mpf__percent' ).length > 0 ) {
        $( '.ll-mpf__percent' ).text( $( '.gf_progressbar_percentage' ).text() );
      }

      if ( $( '.llgq-quoter-back' ).length > 0 ) {
        $( '.llgq-quoter-back' ).append( '<span class="sr-only">Back</span>' );
      }

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        const pages = document.querySelectorAll( '.gform_page' ).length;
        if ( $( '.ll-mpf__percent' ).length > 0 ) {
          $( '.ll-mpf__percent' ).text( $( '.gf_progressbar_percentage' ).text() );
        }

        if ( parseInt( currentPage ) === pages ) {
          $( '.ll-mpf-submit' ).removeClass( 'hidden' );

          $( '.ll-mpf-submit' ).on( 'click', function() {
            $( '.ll-submit' ).trigger( 'click' );
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'll-mpf', COMPONENT );
} )( app );

